// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".templateSuggestionWrapper_ec671d {\n    position: relative;\n    width: 100%;\n}\n\n.inputWrapper_937d64 {\n    position: relative;\n    width: 100%;\n}", "",{"version":3,"sources":["webpack://src/app/common/components/TemplateSuggestion/index.module.scss"],"names":[],"mappings":"AAAA;IACE,kBAAA;IACA,WAAA;AACF;;AAEA;IACE,kBAAA;IACA,WAAA;AACF","sourcesContent":[".templateSuggestionWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.inputWrapper {\n  position: relative;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateSuggestionWrapper": "templateSuggestionWrapper_ec671d",
	"inputWrapper": "inputWrapper_937d64"
};
export default ___CSS_LOADER_EXPORT___;
